import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList, faChartLine, faComments } from "@fortawesome/free-solid-svg-icons";
import {
    faQuoteLeft,
    faEnvelope,
    faPhone,
    faCheckCircle,
    faPlay, faTimes, faLightbulb
} from "@fortawesome/free-solid-svg-icons";
import ReadyToPlan from "../components/ReadyToPlan";

const testimonials = [
    {
        name: "Aditya Sharma",
        title: "Corporate Sales Professional, Delhi",
        heading: "From Confusion to Confidence — A Journey Worth Sharing",
        text: "Before I met SAG Financials, I was overwhelmed by the choices in mutual funds and SIPs. Shepra and her team patiently explained everything, broke down complex terms into simple concepts, and tailored an investment plan that matched my goals. Now, I regularly track my portfolio and feel confident about my financial future. It’s been a transformative experience.",
    },
    {
        name: "Navniti Pd Singh",
        title: "Sr. Advocate , Supreme Court ",
        heading: "Financial Planning That Respects My Goals and Timeline",
        text: "For the past 20 years, I have been taking financial advice from Shepra Anand, Founder of SAG Financials. She and her team have always provided prompt, reliable service and are instantly available whenever I need guidance. Their dedication, transparency, and integrity have been the foundation of their growth. I highly recommend SAG Financials to anyone seeking professional financial and investment planning.",
    },
    {
        name: "Yatendra Solanki",
        title: "Entrepreneur, Noida ",
        heading: "Financial Clarity - The Path to Financial Confidence",
        text: "I wanted to save for my children’s education and also start a small business but wasn’t sure how to balance both. SAG Financials helped me create a realistic plan aligned with my income and priorities. They never rushed me or pushed products — just honest advice and support. Their digital platform makes managing investments easy.",
    },
    {
        name: "Naresh Mahawar",
        title: "Chartered Accountant, Delhi",
        heading: "Expert Tax Planning Helped Me Save Thousands",
        text: "As a finance professional, I understand taxes well, but SAG Financials brought fresh perspectives that optimized my savings. Their strategic advice on deductions, ELSS, and tax-efficient investments was practical and effective. Highly recommended for anyone wanting a professional yet personal advisory service.",
    },
    {
        name: "Yashwin Dhawan",
        title: "IT Professional, Gurugram",
        heading: "Insurance Made Simple and Effective",
        text: "Being in Corporate job , keeps me busy . SAG Financials assessed my personal profile & did financial need analysis.They recommended comprehensive protection plans that fit my budget. Their clear explanations helped me choose the right term insurance and health cover without confusion. It’s peace of mind that’s invaluable.",
    },
    {
        name: "Ashwani Mehra",
        title: "Ex- banker, Delhi",
        heading: "Retirement Planning That Feels Secure and Realistic",
        text: "Planning for retirement felt overwhelming. SAG Financials guided me through creating a goal-based retirement plan suited to my lifestyle and risk appetite. Their team explained how to balance safe investments with growth options, and their tracking tools keep me updated regularly. I now look forward to retirement with confidence.",
    },

];

const Testimonial = () => {
    const isMobile = window.innerWidth < 768;
    const [activeVideo, setActiveVideo] = useState(null);

    const videos = [
        // your local video file (public folder)

        "testimonialsag.mp4",
        "client3.mp4",
        "client.mp4",
        "client8.mp4",

        "client2.mp4",
        "testimonialssag1.mp4",
    ];
    const openWhatsApp = () => {
        const phone = "917011468336";
        const message = "Hi ! I am interested, Please contact me.";
        const encoded = encodeURIComponent(message);
    
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    
        const url = isMobile
            ? `https://wa.me/${phone}?text=${encoded}`
            : `https://web.whatsapp.com/send?phone=${phone}&text=${encoded}`;
    
        window.open(url, "_blank");
    };
    return (
        < div style={{ padding: "150px 0 0 0" }}>

            {/* Intro */}
            <div className="container " >
                <div className="text-center mb-2">
                    <h2 className="fw-bold mb-3" style={{ color: 'var(--heading)' }}>
                        Real Stories. Real Success. Real People.
                    </h2>
                   
                </div>
                <p className="mx-auto" style={{ maxWidth: "800px", color: 'var(--text)' }}>
                        At <strong style={{ color: 'var(--primary)' }}>SAG Financials</strong>, our greatest pride comes from
                        the trust and satisfaction of our clients. Every individual, family,
                        and business we partner with has a unique story — and it's their
                        success that motivates us every day.
                    </p>
                    <p className="mx-auto" style={{ maxWidth: "800px", color: 'var(--text)' }}>
                        Listening to real experiences is the best way to understand what we
                        stand for. Below are genuine testimonials from clients who have
                        transformed their financial lives through personalized planning and
                        expert guidance.
                    </p>
            </div>
            <section
                id="testimonials"
                className="py-3 text-center"
                style={{ backgroundColor: "var(--light-bg)" }}
            >


                <motion.h1
                    className="mb-3 mx-auto fw-bold"
                    style={{
                        color: "var(--text)",
                        maxWidth: "700px",
                        fontSize: "1.09rem",
                        lineHeight: "1.6",
                    }}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                >
                    "Let us hear directly from our clients"{" "}
                    <span
                        style={{
                            color: "var(--primary)",
                            fontWeight: "600",
                            whiteSpace: "nowrap"   // <<< prevents text from splitting into two lines
                        }}
                    >
                        - SAG Financials
                    </span>
                    .
                </motion.h1>


                {/* Video Cards */}
                <div className="container d-flex flex-wrap justify-content-center gap-4">
                    {videos.map((videoUrl, i) => (
                        <motion.div
                            key={i}
                            className="position-relative overflow-hidden rounded-4 bg-white shadow-sm"
                            style={{
                                width: "320px",
                                border: "1px solid var(--secondary)",
                                cursor: "pointer",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                            }}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: i * 0.15 }}
                            whileHover={{
                                scale: 1.05,
                                boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                            }}
                            onClick={() => setActiveVideo(videoUrl)}
                        >
                            <video
                                src={`${videoUrl}#t=0.2`}
                                className="rounded-4 w-100"
                                style={{
                                    height: "200px",
                                    objectFit: "cover",
                                    filter: "brightness(0.8)",
                                }}
                                muted
                                loop
                                playsInline
                                preload="metadata"
                            />

                            {/* Play Button Overlay */}
                            <div
                                className="position-absolute top-50 start-50 translate-middle"
                                style={{
                                    width: "60px",
                                    height: "60px",
                                    backgroundColor: "rgba(255,255,255,0.9)",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    transition: "background-color 0.3s",
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={faPlay}
                                    style={{ color: "var(--primary)", fontSize: "1.5rem" }}
                                />
                            </div>
                        </motion.div>
                    ))}
                </div>

                {/* Popup Video Modal */}
                <AnimatePresence>
                    {activeVideo && (
                        <motion.div
                            className="fixed-top d-flex align-items-center justify-content-center"
                            style={{
                                backgroundColor: "rgba(0, 0, 0, 0.85)",
                                zIndex: 1100,
                                height: "100vh",
                                width: "100vw",
                                backdropFilter: "blur(6px)",
                            }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setActiveVideo(null)} // ✅ Click outside to close
                        >
                            <motion.div
                                className="position-relative"
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0.8, opacity: 0 }}
                                onClick={(e) => e.stopPropagation()} // ✅ Prevent closing when clicking inside
                            >
                                {/* ✅ Close Button */}
                                <button
                                    onClick={() => setActiveVideo(null)}
                                    className="position-absolute top-0 end-0 m-3 border-0 bg-transparent"
                                    style={{
                                        cursor: "pointer",
                                        zIndex: 1200,
                                        backgroundColor: "rgba(0,0,0,0.5)",
                                        borderRadius: "50%",
                                        width: "35px",
                                        height: "35px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition: "background-color 0.3s",
                                    }}
                                    onMouseEnter={(e) =>
                                        (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.3)")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.backgroundColor = "rgba(0,0,0,0.5)")
                                    }
                                >
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        style={{ color: "#fff", fontSize: "1.4rem" }}
                                    />
                                </button>

                                {/* ✅ Video Player */}
                                <motion.video
                                    key={activeVideo}
                                    src={activeVideo}
                                    controls
                                    autoPlay
                                    style={{
                                        maxWidth: "90%",
                                        maxHeight: "80vh",
                                        borderRadius: "20px",
                                        boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
                                    }}
                                />
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>

            </section>


            {/* Testimonials */}
            <div className="container py-5">
                <div className="text-center mb-4">
                    {
                        isMobile ? (<h5 className="fw-bold" style={{ color: 'var(--heading)' }}>"What Our Clients Say About Us"</h5>) : (
                            <h3 className="fw-bold" style={{ color: 'var(--heading)' }}>"What Our Clients Say About Us"</h3>
                        )
                    }
                </div>
                <div className="row g-4">
                    {testimonials.map((t, i) => (
                        <motion.div
                            key={i}
                            className="col-md-6 col-lg-4"
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: i * 0.1 }}

                        >
                            <div
                                className="rounded p-4 h-100 shadow-sm d-flex flex-column"
                                style={{ backgroundColor: 'var(--white)', border: "1px solid var(--primary)" }}
                            >
                                <FontAwesomeIcon
                                    icon={faQuoteLeft}
                                    style={{ color: 'var(--primary)' }}
                                    className="fs-3 mb-3"
                                />

                                <h5 className="fw-bold mb-2" style={{ color: 'var(--heading)' }}>
                                    {t.heading}
                                </h5>

                                {/* TEXT AREA — grows automatically so hr stays aligned */}
                                <div className="flex-grow-1 mb-2" style={{ overflow: "hidden" }}>
                                    <p style={{ color: 'var(--text)' }}>{t.text}</p>
                                </div>

                                {/* FOOTER AREA — always stays at bottom */}
                                <div>
                                    <hr style={{ color: 'var(--primary)' }} />
                                    <p className="fw-semibold mb-0" style={{ color: 'var(--heading)' }}>
                                        {t.name}
                                    </p>
                                    <small style={{ color: 'var(--text)' }}>{t.title}</small>
                                </div>
                            </div>

                        </motion.div>
                    ))}
                </div>
            </div>


            {/* Commitment */}
            {/* Our Commitment to You */}
            <div className="container-fluid py-5" style={{ backgroundColor: 'var(--light-bg)' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold mb-3" style={{ color: 'var(--heading)' }}>"Our Commitment to You"</h2>
                        <p className="mx-auto" style={{ maxWidth: "700px", color: 'var(--text)' }}>
                            Every testimonial reflects what truly defines <strong style={{ color: 'var(--primary)' }}>SAG Financials</strong> —
                            a team dedicated to empowering you with trust, clarity, and long-term success.
                        </p>
                    </div>

                    <div className="row g-4">
                        {[
                            {
                                title: "We Listen First",
                                text: "Your goals, fears, and dreams come first. Every plan begins with understanding you.",
                                icon: faComments,
                            },
                            {
                                title: "We Educate",
                                text: "No confusing jargon — we simplify finance and make every decision easy to understand.",
                                icon: faCheckCircle,
                            },
                            {
                                title: "We Personalize",
                                text: "Your financial roadmap is as unique as your life, crafted with precision and empathy.",
                                icon: faClipboardList,
                            },
                            {
                                title: "We Support",
                                text: "We stand with you at every milestone, offering ongoing reviews, calls, and updates.",
                                icon: faPhone,
                            },
                            {
                                title: "We Deliver Results",
                                text: "Our goal is simple — measurable progress and real financial confidence.",
                                icon: faChartLine,
                            },
                            {
                                title: "We Innovate",
                                text: "Leveraging technology and insights to provide smarter, faster, and more efficient financial solutions.",
                                icon: faLightbulb,
                            }
                        ].map((c, i) => (
                            <motion.div
                                key={i}
                                className="col-md-6 col-lg-4"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: i * 0.1 }}
                            >
                                <div className="rounded p-4 shadow-sm h-100 text-center commitment-card" style={{ border: '1px solid var(--primary)' }}>
                                    <div className="icon-circle mb-3 mx-auto" style={{ backgroundColor: 'var(--light-bg)' }}>
                                        <FontAwesomeIcon
                                            icon={c.icon}
                                            style={{ color: 'var(--primary)' }}
                                            className="fs-3"
                                        />
                                    </div>
                                    <h5 className="fw-bold mb-2" style={{ color: 'var(--heading)' }}>{c.title}</h5>
                                    <p style={{ color: 'var(--text)' }}>{c.text}</p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>


            {/* Share Your Story */}
            <div
                className="py-5 text-center"
                style={{
                    borderStyle: "solid",
                    borderColor: "var(--primary)",
                    borderWidth: "1px 0 1px 0px",
                }}
            >
                <h2 className="fw-bold mb-3" style={{ color: "var(--heading)" }}>
                    Share Your Story
                </h2>

                <p className="mx-auto" style={{ maxWidth: "700px", color: "var(--text)" }}>
                    Have you worked with{" "}
                    <strong style={{ color: "var(--primary)" }}>SAG Financials</strong>? We'd
                    love to hear from you! Your story could inspire others to take control of
                    their finances.
                </p>

                <p className="fs-5" style={{ color: "var(--text)" }}>
                    <FontAwesomeIcon
                        icon={faEnvelope}
                        style={{ color: "var(--primary)" }}
                        className="me-2"
                    />
                    <strong>Email:</strong>{" "}
                    <a
                        href="mailto:connect@sagfinancials.com"
                        style={{ color: "var(--primary)", textDecoration: "none" }}
                    >
                        connect@sagfinancials.com
                    </a>
                    &nbsp; | &nbsp;
                    <FontAwesomeIcon
                        icon={faPhone}
                        style={{ color: "var(--primary)" }}
                        className="me-2"
                    />
                    <strong>WhatsApp:</strong>{" "}
                    <a
                      onClick={openWhatsApp}
                        rel="noopener noreferrer"
                        style={{ color: "var(--primary)", textDecoration: "none",cursor:'pointer' }}
                    >
                        +91 70114 68336
                    </a>
                </p>
            </div>




            <ReadyToPlan />
        </div>
    );
};

export default Testimonial;
